import { useOnboarding } from '../../context/OnboardingContext';
import ElementRenderer from '../elements/ElementRenderer';

const Header = () => {
    const { data } = useOnboarding();

    if (!data || !data.header || data.header.length === 0) return null;

    return (
        <div className="header-container">
            {data.header.map((element, index) => (
                <ElementRenderer key={index} element={element} />
            ))}
        </div>
    );
};

export default Header;
